import { useEffect, useState } from 'react';
import { getLiquidClasses } from 'business/services/IngredientService';

const useLiquidClassList = (showLiquidClassModal, refetchCounter) => {
  const [liquidClassList, setLiquidClassList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const liqClassList = await getLiquidClasses();
      setLiquidClassList(liqClassList);
    };
    if (showLiquidClassModal) {
      fetchData();
    }
  }, [showLiquidClassModal, refetchCounter]);

  return liquidClassList;
};

export default useLiquidClassList;
